require('./bootstrap');

// Import des composants personnalisés
require('./components/ranking-popup');
require('./components/tooltip');
